"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumnConfig = void 0;
const button_1 = require("@components/button");
const react_1 = __importDefault(require("react"));
const getColumnConfig = (editHandler) => [
    {
        title: "Wallet",
        width: 1,
        cellRender: ({ wallet }) => wallet,
    },
    { title: "Referral Rate", width: 1, cellRender: ({ referralRate }) => referralRate },
    {
        width: "80px",
        cellRender: ({ wallet, referralRate }) => (react_1.default.createElement(button_1.Button, { onClick: () => editHandler(wallet, referralRate), type: "primary" }, "Edit")),
    },
];
exports.getColumnConfig = getColumnConfig;
